import React from 'react';
import './Header.css';

function Header() {
  // Smooth scroll handler
  const handleScroll = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="header">
      <div className="logo">Matrika</div>
      <ul className="nav-links">
        <li className="active">
          <a href="#home" onClick={e => handleScroll(e, 'home')}>Home</a>
        </li>
        <li>
          <a href="#about" onClick={e => handleScroll(e, 'about')}>About</a>
        </li>
        <li>
          <a href="#services" onClick={e => handleScroll(e, 'services')}>Services</a>
        </li>
        <li>
          <a href="#projects" onClick={e => handleScroll(e, 'projects')}>Projects</a>
        </li>
        {/*<li><a href="#resume" onClick={e => handleScroll(e, 'resume')}>Resume</a></li>*/}
        <li>
          <a href="#contact" onClick={e => handleScroll(e, 'contact')}>
            <button className="contact-button">Contact Me</button>
          </a>
        </li>
      </ul>
    </nav>
  );
}

export default Header;
